import React, { useState } from 'react';
import { Icon } from '@iconify/react';
import { ImageWithFallback } from '../components/media/ImageWithFallback';

function AikpokpodionFellowship() {
    const [activeTab, setActiveTab] = useState('overview');

    return (
        <div className="aikpokpodion-page">
            {/* Hero Section */}
            <section className="program-hero aikpokpodion-hero">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-7">
                            <div className="program-badge">
                                <Icon icon="mdi:certificate" />
                                <span>Signature White Label Initiative</span>
                            </div>
                            <h1 className="program-hero-title animate-slide-up">
                                Prof. P. Aikpokpodion Genetics and Biotechnology Innovation Fellowship
                            </h1>
                            <p className="program-hero-subtitle animate-slide-up delay-1">
                                Honoring excellence in genetics and biotechnology research with prestigious
                                fellowships that advance scientific discovery and innovation
                            </p>
                            <div className="program-hero-buttons animate-slide-up delay-2">
                                <button className="btn btn-apply">
                                    <Icon icon="mdi:application" className="me-2" />
                                    Apply for Fellowship
                                </button>
                                <button className="btn btn-donate-program">
                                    <Icon icon="mdi:hand-heart" className="me-2" />
                                    Support Fellows
                                </button>
                            </div>
                        </div>
                        <div className="col-lg-5">
                            <div className="fellowship-visual animate-fade-in delay-2">
                                <ImageWithFallback
                                    src="https://images.unsplash.com/photo-1707944745899-104a4b12d945?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzY2llbmNlJTIwbGFib3JhdG9yeSUyMHJlc2VhcmNofGVufDF8fHx8MTc2MjQwODIwM3ww&ixlib=rb-4.1.0&q=80&w=1080"
                                    alt="Genetics Research"
                                    className="fellowship-image"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Legacy Section */}
            <section className="legacy-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="section-header">
                                <span className="section-label">Honoring a Legacy</span>
                                <h2 className="section-title">About Prof. P. Aikpokpodion</h2>
                            </div>
                            <p className="legacy-text">
                                This fellowship is named in honor of Professor P. Aikpokpodion, a pioneering
                                figure in genetics and biotechnology research in West Africa. Throughout his
                                distinguished career, Prof. Aikpokpodion made groundbreaking contributions to
                                crop genetics, biotechnology applications in agriculture, and capacity building
                                for young scientists across the continent.
                            </p>
                            <p className="legacy-text">
                                His commitment to scientific excellence, mentorship, and the advancement of
                                biotechnology for societal benefit continues to inspire the next generation of
                                researchers. This fellowship carries forward his vision of nurturing scientific
                                talent and promoting innovative research that addresses real-world challenges.
                            </p>
                        </div>
                        <div className="col-lg-4">
                            <div className="legacy-quote">
                                <Icon icon="mdi:format-quote-open" className="quote-icon" />
                                <p>
                                    "Science is not just about discovery—it's about using that knowledge to
                                    improve lives and build a better future."
                                </p>
                                <div className="quote-author">
                                    <strong>Prof. P. Aikpokpodion</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Fellowship Details */}
            <section className="fellowship-details">
                <div className="container">
                    <div className="section-header text-center">
                        <span className="section-label">Fellowship Package</span>
                        <h2 className="section-title">What Fellows Receive</h2>
                    </div>

                    <div className="row g-4">
                        <div className="col-lg-4 col-md-6">
                            <div className="benefit-card">
                                <div className="benefit-icon">
                                    <Icon icon="mdi:cash-multiple" />
                                </div>
                                <h4>Research Grant</h4>
                                <div className="benefit-amount">$25,000</div>
                                <p>Annual research funding for innovative projects in genetics and biotechnology</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="benefit-card">
                                <div className="benefit-icon">
                                    <Icon icon="mdi:school" />
                                </div>
                                <h4>Training Support</h4>
                                <div className="benefit-amount">$10,000</div>
                                <p>Funding for workshops, courses, and skill development programs</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="benefit-card">
                                <div className="benefit-icon">
                                    <Icon icon="mdi:airplane" />
                                </div>
                                <h4>Conference Travel</h4>
                                <div className="benefit-amount">$5,000</div>
                                <p>Travel grants for presenting research at international conferences</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="benefit-card">
                                <div className="benefit-icon">
                                    <Icon icon="mdi:account-tie" />
                                </div>
                                <h4>Expert Mentorship</h4>
                                <p>One-on-one mentorship with leading scientists in genetics and biotechnology</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="benefit-card">
                                <div className="benefit-icon">
                                    <Icon icon="mdi:library" />
                                </div>
                                <h4>Resource Access</h4>
                                <p>Access to research databases, laboratory facilities, and academic resources</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="benefit-card">
                                <div className="benefit-icon">
                                    <Icon icon="mdi:earth" />
                                </div>
                                <h4>Global Network</h4>
                                <p>Connection to international research community and collaboration opportunities</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Tabs Section */}
            <section className="fellowship-tabs">
                <div className="container">
                    <div className="tabs-wrapper">
                        <div className="tabs-nav">
                            <button
                                className={`tab-btn ${activeTab === 'overview' ? 'active' : ''}`}
                                onClick={() => setActiveTab('overview')}
                            >
                                <Icon icon="mdi:information" />
                                Overview
                            </button>
                            <button
                                className={`tab-btn ${activeTab === 'eligibility' ? 'active' : ''}`}
                                onClick={() => setActiveTab('eligibility')}
                            >
                                <Icon icon="mdi:clipboard-check" />
                                Eligibility
                            </button>
                            <button
                                className={`tab-btn ${activeTab === 'application' ? 'active' : ''}`}
                                onClick={() => setActiveTab('application')}
                            >
                                <Icon icon="mdi:file-document" />
                                Application
                            </button>
                            <button
                                className={`tab-btn ${activeTab === 'fellows' ? 'active' : ''}`}
                                onClick={() => setActiveTab('fellows')}
                            >
                                <Icon icon="mdi:account-group" />
                                Current Fellows
                            </button>
                        </div>

                        <div className="tabs-content">
                            {activeTab === 'overview' && (
                                <div className="tab-pane">
                                    <h3>Fellowship Overview</h3>
                                    <p>
                                        The Prof. P. Aikpokpodion Genetics and Biotechnology Innovation Fellowship
                                        is a competitive program designed to support exceptional early-career researchers
                                        pursuing innovative projects in genetics, genomics, biotechnology, and related fields.
                                    </p>
                                    <div className="overview-highlights">
                                        <div className="highlight">
                                            <Icon icon="mdi:calendar" />
                                            <div>
                                                <strong>Duration</strong>
                                                <span className='ms-2'>2 years (renewable for 1 additional year)</span>
                                            </div>
                                        </div>
                                        <div className="highlight">
                                            <Icon icon="mdi:account-multiple" />
                                            <div>
                                                <strong>Fellows per Year</strong>
                                                <span className='ms-2'>5 fellows selected annually</span>
                                            </div>
                                        </div>
                                        <div className="highlight">
                                            <Icon icon="mdi:chart-line" />
                                            <div>
                                                <strong>Success Rate</strong>
                                                <span className='ms-2'>90% of fellows publish in top-tier journals</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {activeTab === 'eligibility' && (
                                <div className="tab-pane">
                                    <h3>Eligibility Criteria</h3>
                                    <div className="criteria-list">
                                        <div className="criteria-item">
                                            <Icon icon="mdi:check-circle" className="criteria-check" />
                                            <div>
                                                <strong>Academic Qualification</strong>
                                                <p>PhD or equivalent in genetics, biotechnology, molecular biology, or related field</p>
                                            </div>
                                        </div>
                                        <div className="criteria-item">
                                            <Icon icon="mdi:check-circle" className="criteria-check" />
                                            <div>
                                                <strong>Research Experience</strong>
                                                <p>Minimum 2 years post-doctoral research experience or equivalent</p>
                                            </div>
                                        </div>
                                        <div className="criteria-item">
                                            <Icon icon="mdi:check-circle" className="criteria-check" />
                                            <div>
                                                <strong>Publication Record</strong>
                                                <p>At least 3 peer-reviewed publications in recognized journals</p>
                                            </div>
                                        </div>
                                        <div className="criteria-item">
                                            <Icon icon="mdi:check-circle" className="criteria-check" />
                                            <div>
                                                <strong>Research Proposal</strong>
                                                <p>Innovative project addressing real-world challenges in genetics/biotechnology</p>
                                            </div>
                                        </div>
                                        <div className="criteria-item">
                                            <Icon icon="mdi:check-circle" className="criteria-check" />
                                            <div>
                                                <strong>Institutional Affiliation</strong>
                                                <p>Active research position at a recognized institution</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {activeTab === 'application' && (
                                <div className="tab-pane">
                                    <h3>Application Requirements</h3>
                                    <p>Applications are accepted annually from September 1 to November 30.</p>
                                    <div className="requirements-list">
                                        <div className="requirement">
                                            <div className="req-number">1</div>
                                            <div className="req-content">
                                                <h5>Completed Application Form</h5>
                                                <p>Online application with personal and professional details</p>
                                            </div>
                                        </div>
                                        <div className="requirement">
                                            <div className="req-number">2</div>
                                            <div className="req-content">
                                                <h5>Research Proposal</h5>
                                                <p>Detailed proposal (max 10 pages) outlining objectives, methodology, and expected impact</p>
                                            </div>
                                        </div>
                                        <div className="requirement">
                                            <div className="req-number">3</div>
                                            <div className="req-content">
                                                <h5>Curriculum Vitae</h5>
                                                <p>Complete CV including education, publications, presentations, and awards</p>
                                            </div>
                                        </div>
                                        <div className="requirement">
                                            <div className="req-number">4</div>
                                            <div className="req-content">
                                                <h5>Letters of Recommendation</h5>
                                                <p>Three letters from established researchers in your field</p>
                                            </div>
                                        </div>
                                        <div className="requirement">
                                            <div className="req-number">5</div>
                                            <div className="req-content">
                                                <h5>Supporting Documents</h5>
                                                <p>Copies of key publications and proof of institutional affiliation</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="application-cta">
                                        <button className="btn btn-application">
                                            <Icon icon="mdi:application" className="me-2" />
                                            Start Your Application
                                        </button>
                                        <a href="#" className="application-guide">
                                            <Icon icon="mdi:file-download" className="me-2" />
                                            Download Application Guide
                                        </a>
                                    </div>
                                </div>
                            )}

                            {activeTab === 'fellows' && (
                                <div className="tab-pane">
                                    <h3>Current Fellows (2025 Cohort)</h3>
                                    <div className="fellows-grid">
                                        <div className="fellow-card">
                                            <div className="fellow-info">
                                                <h5>Dr. Oluwaseun Adebayo</h5>
                                                <p className="fellow-institution">University of Ibadan, Nigeria</p>
                                                <p className="fellow-research">
                                                    CRISPR-based approaches for developing disease-resistant cassava varieties
                                                </p>
                                            </div>
                                        </div>
                                        <div className="fellow-card">
                                            <div className="fellow-info">
                                                <h5>Dr. Amina Hassan</h5>
                                                <p className="fellow-institution">Kwame Nkrumah University, Ghana</p>
                                                <p className="fellow-research">
                                                    Genomic analysis of antimicrobial resistance in tropical pathogens
                                                </p>
                                            </div>
                                        </div>
                                        <div className="fellow-card">
                                            <div className="fellow-info">
                                                <h5>Dr. Kenneth Okonkwo</h5>
                                                <p className="fellow-institution">Makerere University, Uganda</p>
                                                <p className="fellow-research">
                                                    Biotechnology applications in sustainable agriculture for smallholder farmers
                                                </p>
                                            </div>
                                        </div>
                                        <div className="fellow-card">
                                            <div className="fellow-info">
                                                <h5>Dr. Grace Mwangi</h5>
                                                <p className="fellow-institution">University of Nairobi, Kenya</p>
                                                <p className="fellow-research">
                                                    Genetic markers for early detection of hereditary diseases in African populations
                                                </p>
                                            </div>
                                        </div>
                                        <div className="fellow-card">
                                            <div className="fellow-info">
                                                <h5>Dr. Ibrahim Koroma</h5>
                                                <p className="fellow-institution">University of Sierra Leone</p>
                                                <p className="fellow-research">
                                                    Molecular approaches to understanding and combating vector-borne diseases
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </section>

            {/* Impact Section */}
            <section className="fellowship-impact">
                <div className="container">
                    <div className="section-header text-center">
                        <span className="section-label">Our Impact</span>
                        <h2 className="section-title">Fellowship Achievements</h2>
                    </div>

                    <div className="row g-4">
                        <div className="col-lg-3 col-md-6">
                            <div className="impact-stat">
                                <Icon icon="mdi:account-school" className="impact-icon" />
                                <div className="impact-number">25</div>
                                <div className="impact-label">Fellows Supported</div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="impact-stat">
                                <Icon icon="mdi:file-document" className="impact-icon" />
                                <div className="impact-number">120+</div>
                                <div className="impact-label">Research Papers Published</div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="impact-stat">
                                <Icon icon="mdi:lightbulb" className="impact-icon" />
                                <div className="impact-number">15</div>
                                <div className="impact-label">Patents Filed</div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="impact-stat">
                                <Icon icon="mdi:earth" className="impact-icon" />
                                <div className="impact-number">8</div>
                                <div className="impact-label">Countries Represented</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default AikpokpodionFellowship;
